import { Component, ChangeDetectorRef, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalComponent } from "@shared/components/modal/modal.component";
import { UserRoleComponent } from "./create-user/user-role/user-role.component";
import { SuccessPopupComponent } from "./create-user/success-popup/success-popup.component";
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from "@angular/router";
import { SharedModule } from "@shared/shared_module";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";
import { DraftPopupComponent } from "./create-user/draft-popup/draft-popup.component";
import { UserRequestsComponent } from "./user-requests/user-requests.component";
import { UserListComponent } from "./user-list/user-list.component";
import { filter } from 'rxjs/operators';
import { UserFormComponent } from "./create-user/create-new-user/user-form.component";


@Component({
  selector: "app-user-management",
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    UserRoleComponent,
    UserFormComponent,
    SuccessPopupComponent,
    SharedModule,
    PrimeNGSharedModule,
    DraftPopupComponent,
    UserRequestsComponent,
    UserListComponent,
    RouterModule,
  ],
  templateUrl: "./user-management.component.html",
  styleUrls: ["./user-management.component.scss"],
})
export class UserManagementComponent implements OnInit {
  activeTab: 'requests' | 'users' = 'requests';
  requestTotalRecords: number = 0;

  showCreateUserDialog: boolean = false;
  showNewUserDialog: boolean = false;
  successPopupVisible = false;
  successPopupData: any;
  showDraftPopup: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateActiveTabFromUrl();
    });

    this.updateActiveTabFromUrl();
  }

  private updateActiveTabFromUrl(): void {
  const path = this.router.url.split('?')[0]; 
  const urlSegments = path.split('/').filter(seg => seg); 
   const lastSegment = urlSegments[urlSegments.length - 1];

    if (lastSegment === 'requests') {
      this.activeTab = 'requests';
    } else if (lastSegment === 'users') {
      this.activeTab = 'users';
    } else {
      this.activeTab = 'requests';
      if (this.router.url === '/user-management') {
        this.router.navigate(['./requests'], { relativeTo: this.activatedRoute, replaceUrl: true });
      }
    }
    this.cdr.detectChanges();
  }

  navigateToTab(tabName: 'requests' | 'users'): void {
    this.router.navigate([`./${tabName}`], { relativeTo: this.activatedRoute });
  }

  onActivate(componentRef: any): void {
    if (componentRef instanceof UserRequestsComponent) {
      componentRef.totalRequestsChanged.subscribe((total: number) => {
        this.requestTotalRecords = total;
        this.cdr.detectChanges();
      });
    }
  }

 handleCreateUser(): void {
    // Directly open the new user dialog
    this.showNewUserDialog = true;
    this.cdr.detectChanges(); // Ensure change detection runs to show the dialog
  }


  onShowSuccessPopup(popupData: any) {
    this.successPopupData = popupData;
    this.successPopupVisible = true;
    this.cdr.detectChanges();
  }

  onSuccessPopupClose() {
    this.successPopupVisible = false;
  }

  handleAddAnotherUser() {
    this.showCreateUserDialog = true;
    this.successPopupVisible = false;
  }

  onConfirmDraft(): void {
    this.showNewUserDialog = false;
    this.showDraftPopup = true;
    this.cdr.detectChanges();
  }

  onCancelDraft(): void {
    this.showDraftPopup = false;
  }

  navigateToDraftTab(): void {
    this.navigateToTab('users');
    this.showDraftPopup = false;
    this.cdr.detectChanges();
  }

  onCloseNewUserDialog(): void {
    this.showNewUserDialog = false;
    // Potentially refresh data in user-management if it displays user data
  }

   onUserCreated(event: any): void {
    // If user-management component also displays user data, refresh it here
  }

}